import React from 'react';
import { Alert as DsAlert } from '@livecommerce/design-system';
import Portal from 'pages/Theming/utils/Portal.js';
import { useAlert } from 'contexts/AlertContext.jsx';

const Alert = () => {
  const { title, description, variant, isOpen, actionText, actionProps } = useAlert();

  return isOpen ? (
    <Portal id="alert">
      <DsAlert
        title={title}
        description={description}
        variant={variant}
        style={styles.alert}
        actionText={actionText}
        actionProps={actionProps}
      />
    </Portal>
  ) : null;
};

const styles = {
  alert: {
    position: 'fixed',
    left: '50%',
    transform: 'translateX(-50%)',
    bottom: '30px',
    display: 'flex',
    justifyContent: 'center',
    zIndex: 999999,
  },
};

export default Alert;
